import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormUtil } from '../utils/form-util';
import { catchError, debounceTime, distinctUntilChanged, map, Observable, of, shareReplay, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export class CustomValidators {
  
  public static match(leftControlName: string, rightControlName: string, message: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let leftControl = control.get(leftControlName);
      let rightControl = control.get(rightControlName);

      if (leftControl == null || rightControl == null) {
        FormUtil.removeError(rightControl, 'match');
        return null;
      }

      if (leftControl.invalid || rightControl.invalid) {
        FormUtil.removeError(rightControl, 'match');
        return null;
      }

      if (leftControl.disabled || rightControl.disabled) {
        FormUtil.removeError(rightControl, 'match');
        return null;
      }

      if (leftControl.value === rightControl.value) {
        FormUtil.removeError(rightControl, 'match');
        return null;
      }

      FormUtil.addError(rightControl, {
        match: {
          message: message
        }
      });

      return {
        match: {
          message: message
        }
      };
    };
  }

  public static pattern(pattern: RegExp | RegExp[], key: string, message: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      FormUtil.removeError(control, key);

      let value = control.value;
      let isValid = Array.isArray(pattern) ? pattern.every(p => p.test(value)) : pattern.test(value);

      if (isValid) {
        return null;
      } else {
        return {
          [key]: {
            message: message
          }
        };
      }
    }
  }

  public static mod10Validator(control: FormControl): { [key: string]: any } | null {
    const cedula = control?.value;
    if (!validarMod10(cedula) && cedula?.length === 11) {
      return { 'invalidCedula': true };
    }
    return null;
  }

  public  static userExistAsyncValidator() {
    const authService = inject(AuthService);

    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null); 
      }

      const validation$ = of(control.value).pipe(
        distinctUntilChanged(),
        debounceTime(300),
        switchMap(value =>
          authService.userExist(value).pipe(
            map(response => (!response ? null : { exist: true })),
          )
        ),
        shareReplay(1)
      );
      return validation$;
    };
  }

  public  static emailExistAsyncValidator() {
    const authService = inject(AuthService);

    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null); 
      }

      const validation$ = of(control.value).pipe(
        distinctUntilChanged(),
        debounceTime(300),
        switchMap(value =>
          authService.emailExist(value).pipe(
            map(response => (!response ? null : { exist: true })),
          )
        ),
        shareReplay(1)
      );
      return validation$;
    };
  }


}

function validarMod10(cedula: string): boolean {
  cedula = cedula?.replaceAll('-', '')
  if (!cedula || cedula?.length !== 11) {
    return false;
  }

  let checksum = 0;

  let j = 1;

  for (let i = cedula.length - 1; i >= 0; i--) {
    const digit = parseInt(cedula[i], 10);
    if (isNaN(digit)) {
      return false;
    }
    let calc = digit * j;
    if (calc > 9) {
      checksum += 1;
      calc -= 10;
    }
    checksum += calc;
    j = (j === 1) ? 2 : 1;
  }
  return checksum % 10 === 0;
}